import { render, staticRenderFns } from "./HeadAgent.vue?vue&type=template&id=166ca9c4&scoped=true"
import script from "./HeadAgent.vue?vue&type=script&lang=js"
export * from "./HeadAgent.vue?vue&type=script&lang=js"
import style0 from "./HeadAgent.vue?vue&type=style&index=0&id=166ca9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ca9c4",
  null
  
)

export default component.exports